<template>
  <section id="step8" class="p-content-plan-manual-step">
    <div class="l-container">
      <h2 class="c-title--x-large">
        STEP8 効果検証を開始する
      </h2>
      <div class="l-rows">
        <p>
          <strong
            >コンテンツSEOは、記事をアップすれば終わりではありません。成果を計測し、継続的に改善を行っていくことで成果を最大化させることができます。</strong
          ><br />
          記事のアップ後は、すぐに効果検証を開始するため、以下の手順でSEARCH
          WRITEでの操作をお願いします。
        </p>
        <div class="c-panel">
          <ol class="c-list--decimal c-list-marker--bold l-rows--small">
            <li>
              タスクリストから、該当するタスクの「施策完了日」を入力する<br />
              <a
                :href="taskListLink"
                target="_blank"
                class="c-link--blank c-link--underline"
                >タスクリスト | {{ siteName }}
              </a>
            </li>
            <li>
              完了した施策を「完了」フェーズに移動させる
            </li>
            <li>
              「成果チェックで変化を見る」ボタンをクリックし、検索順位チェックに登録する
            </li>
            <li>約3か月後に成果を見て、改善施策を検討する</li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    createdAt: {
      type: String,
      required: true
    },
    keyword: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      siteName: process.env.VUE_APP_SITENAME
    };
  },
  computed: {
    taskListLink() {
      return `${process.env.VUE_APP_SITEURL}${this.project.id}/task-list?referrer=content_plan_manual&createdAt=${this.createdAt}&keyword=${this.keyword}`;
    }
  }
};
</script>
